<template>
  <div class="modal fade" id="modalChangeFinancialEmail" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">Alteração de email financeiro.</h4>
        </div>
  
        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>E-mail</label>
              <input v-model="email" type="email" class="form-control" name="email" placeholder="Email" required>
              <span v-if="errorMsgEmail" class="error-msg">{{errorMsgEmail}}</span>
            </div>
          </form>
        </div>
  
        <div class="modal-footer">
          <button v-on:click="changeEmail()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import {
    CHANGE_COMPANY_FINANCIAL_EMAIL
  } from "../../../urlConfig";
  import {
    REQUEST_SERVICE
  } from "../../../requestConfig";
  import {
    UTIL_SERVICE
  } from "../../../utils";
  
  export default {
    name: "modalChangeFinancialEmail",
    props: ['dataCompanyModal'],
    data() {
      return {
        modalContext: '',
        errorMsgEmail: '',
        companyValue: '',
        email: '',
        successChangeEmail: '',
        loadingChange: false
      }
    },
    watch: {
      dataCompanyModal: function (val) {
        this.companyValue = val;
        this.modalContext = val.context;
      },
      successChangeEmail: function (val) {
        this.$emit('update:newFinancialEmail', val)
      },
    },
    methods: {
      closeModal() {
        $('#modalChangeFinancialEmail').modal('toggle');
      },
      changeEmail() {
        this.errorMsgEmail = "";
  
        if (this.email) {
          let financialEmail = this.email;
          let companyId = this.dataCompanyModal.companyValue.id;
          let contexCode = this.dataCompanyModal.modalContext;
  
          //validação email
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          let testEmail =  emailRegex.test(financialEmail);
          this.loadingChange = true;
          if (!testEmail) {
            this.closeModal();
            swal({
                title: "Aviso",
                text: "Preencha um email válido.",
                icon: "warning",
                catch: true,
                dangerMode: true
              });
              this.loadingChange = false;
              throw new TypeError("Preencha um email válido.");
          }
          //envio
          UTIL_SERVICE.console("DATA SEND:", {companyId, financialEmail});
          REQUEST_SERVICE.requestContext('PUT', CHANGE_COMPANY_FINANCIAL_EMAIL, contexCode, {companyId, financialEmail})
          .then((response) => {
            UTIL_SERVICE.console("RESULT CHANGE_COMPANY_FINANCIAL_EMAIL:", response);
            this.successChangeEmail = this.email;

            swal("Aviso", "Empresa atualizada com sucesso.", "success");
            $('#modalChangeFinancialEmail').modal('toggle');
            this.loadingChange = false;
          })
          .catch((error) => {
            UTIL_SERVICE.console('RESULT CHANGE_FINANCIAL_EMAIL ERROR: ', error)
            $('#modalChangeFinancialEmail').modal('toggle');
              swal("Aviso", "Problema no servidor, contate a equipe de desenvolvimento.", "error");
              this.loadingChange = false;
          })
        } else {
          this.errorMsgEmail = "Preencha um email válido.";
        }
      }
    }
  }
  </script>
  
  <style lang="scss">
  #modalChangeFinancialEmail {
    .error-msg {
      font-size: 12px;
      color: #e74a4e;
      text-align: left;
      display: block;
    }
  
    .modal-header {
      padding: 15px 15px 0;
      border-bottom: none;
    }
  
    .modal-body {
      padding-left: 80px;
      padding-right: 80px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  
    .title-modal {
      text-align: center;
      padding-top: 10px;
      font-weight: bold;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  
    .modal-footer {
      .close-btn {
        border-radius: 4px !important;
        background-color: #8b8787;
        padding: 7px 35px 7px 35px;
        font-weight: 600;
        text-align: center;
        color: #fff;
        border: none;
        height: 36px;
      }
  
      .btn-register {
        border-radius: 4px !important;
        background-color: #3598dc;
        padding: 7px 35px 7px 35px;
        font-weight: 600;
        text-align: center;
        color: #fff;
        border: none;
        height: 36px;
      }
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeFinancialEmail.vue